export default "__VITE_ASSET__DOf5cQTV__"